import Button from "@/components/ui/Button";
import { ArrowLeft, ArrowRight, Rocket } from "lucide-react";

interface WizardNavProps {
  currentStep: 1 | 2 | 3;
  canNext: boolean;
  submitting?: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export default function WizardNav({
  currentStep,
  canNext,
  submitting,
  onBack,
  onNext,
  onSubmit,
}: WizardNavProps) {
  return (
    <div className="sticky bottom-0 z-10 border-t border-border bg-background px-4 py-3">
      <div className="mx-auto flex max-w-lg items-center gap-3">
        {currentStep > 1 && (
          <Button variant="ghost" onClick={onBack} className="shrink-0">
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
        )}
        <div className="flex-1" />
        {currentStep < 3 ? (
          <Button
            variant="primary"
            onClick={onNext}
            disabled={!canNext}
            className="shrink-0"
          >
            Next
            <ArrowRight className="h-4 w-4" />
          </Button>
        ) : (
          <Button
            variant="primary"
            onClick={onSubmit}
            loading={submitting}
            disabled={!canNext}
            className="shrink-0"
          >
            <Rocket className="h-4 w-4" />
            Create Game
          </Button>
        )}
      </div>
    </div>
  );
}
